import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor() { }

  // To call the function among any component
  private messageSubject = new Subject<{functionName: string, toComponent: string}>();
  message$ = this.messageSubject.asObservable();
  CallFunction(message: {functionName: string, toComponent: string}) {
    this.messageSubject.next(message);
  }
}
